export function initSmoothScroll(): void {
  // Handle anchor links with smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();

        const headerHeight = 80; // Approximate header height
        const targetPosition = (target as HTMLElement).offsetTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });

        // Update URL without jumping
        if (history.pushState) {
          history.pushState(null, '', href);
        }
      }
    });
  });
}
